<template>
  <iframe ref="iframe" :src="iframeSrc" style="border: 0; height: 100%; width: 100%"></iframe>
</template>

<script>
import Url from 'url-parse'
import triplaLocalStorage from 'Utilities/triplaLocalStorage'
import { useUserStore } from 'Store/user'
import { useAppStore } from 'Store/app'
import { useSettingsStore } from 'Store/settings'
import { mapState } from 'pinia'

export default {
  name: 'BookingWidgetIframe',

  props: {
    params: { type: Object, default: () => ({}) }
  },

  setup() {
    const userStore = useUserStore()
    const appStore = useAppStore()
    const settingsStore = useSettingsStore()

    return { userStore, appStore, settingsStore }
  },

  data() {
    return {
      iframeSrc: ''
    }
  },

  computed: {
    ...mapState(useSettingsStore, {
      isFacilitySignInEnabled: 'getFacilitySignIn',
      settings: 'getSettings'
    }),

    ...mapState(useAppStore, {
      isEmailConfirmationDone: 'isEmailConfirmationDone'
    }),

    knownUser() {
      return this.userStore.user
    }
  },

  created() {
    this.iframeSrc = this.genIframeSrc()
  },

  methods: {
    genIframeSrc() {
      const url = new Url(window.location, '/', true)
      let path = this.params.route || 'chat-sign-up'

      if (
        url.query.triplabot_confirm_user &&
        !this.isEmailConfirmationDone &&
        this.isFacilitySignInEnabled
      ) {
        let routePath = url.query.triplabot_confirm_user
        if (routePath.startsWith('#/')) {
          routePath = routePath.slice(2)
        }
        path = `${routePath}&`
        this.appStore.setEmailConfirmationStatus('done')
      }

      const bwUrl = this.settingsStore.bookingWidgetURL
      const autoMessageAuthIdParam = this.appStore.autoMessageAuthId
        ? `&auth_auto_message_id=${this.appStore.autoMessageAuthId}`
        : ''
      const triplabotUserId =
        this.knownUser.id ||
        triplaLocalStorage.getItem('triplabot_known_user_id') ||
        triplaLocalStorage.getItem('triplabot_user_id')
      const triplabotUserIdParam = triplabotUserId ? `&triplabot_user_id=${triplabotUserId}` : ''
      let addtionalParams = ''

      if (this.params) {
        Object.entries(this.params).forEach(([key, value]) => {
          if (!value) return
          addtionalParams += `&${key}=${value}`
        })
      }
      const utmSource = 'tripla_bot'
      const utmMedium = this.appStore.autoMessageAuthType || 'menu'
      const utmCampaign = this.appStore.autoMessageAuthId
        ? `${this.appStore.autoMessageAuthId}`
        : ''

      return `${bwUrl}/${path}?code=${this.appStore.websiteFacilityCode}&parentUrl=${location.origin}${location.pathname}&locale=${this.$i18n.locale}&uri=${this.appStore.baseURL}&iframe=triplabot${autoMessageAuthIdParam}${triplabotUserIdParam}${addtionalParams}&utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`
    }
  }
}
</script>
